import util from "@/utils/index";
const mutations = {
    // 车辆列表
    carList(state, params) {
        const data = params.data;
        // 遍历树形数据，重组数据
        util.eachList(data, function(item) {
            const flag = item.flag;
            item.showTotal = flag ? item.total : '- -';
            item.showTotalFine = flag ? item.totalFine : '- -';
            item.showTotalDegree = flag ? item.totalDegree : '- -';
            item.flagCls = flag ? 'c_333' : 'c_999';
        });
        state.carList = data;
    },
    // 驾照列表
    drivingList(state, params) {
        const data = params.data;
        // 遍历树形数据，重组数据
        util.eachList(data, function(item) {
            item.showScore = item.show ? item.score : '- -';
            item.showText = item.show ? '刷新' : '查询';
            item.number = util.plusXing(item.number, 4, 14);
            item.fileNo = util.plusXing(item.fileNo, 4, 8)
        });
        state.drivingList = data;
    }
}
export default mutations